import {
  AppstoreOutlined,
  CalendarOutlined,
  FileOutlined,
  UnorderedListOutlined,
  SaveOutlined,
  TeamOutlined,
  VideoCameraAddOutlined,
  ReadOutlined,
  FileTextOutlined
} from '@ant-design/icons';
import { DOCTOR_HOW_IT_WORKS_PAGES } from '@medicusunion/front-utils';

import { SidebarMenuType } from 'components/layout/PrivateLayout/types';

export const SIDEBAR_ICONS = {
  dashboard: <AppstoreOutlined />,
  appointments: <UnorderedListOutlined />,
  patients: <TeamOutlined />,
  invoices: <FileOutlined />,
  report: <FileTextOutlined />,
  calendar: <CalendarOutlined />,
  'video-call': <VideoCameraAddOutlined />,
  dicom: <SaveOutlined />,
  howItWorks: <ReadOutlined />
};

export const SIDEBAR_MENU: SidebarMenuType[] = [
  {
    label: 'dashboard',
    key: '',
    to: '/',
    icon: SIDEBAR_ICONS.dashboard
  },
  {
    label: 'appointments',
    key: 'appointments',
    to: '/appointments',
    icon: SIDEBAR_ICONS.appointments
  },
  {
    label: 'patients',
    key: 'patients',
    to: '/patients',
    icon: SIDEBAR_ICONS.patients
  },
  {
    label: 'invoices',
    key: 'invoices',
    to: '/invoices',
    icon: SIDEBAR_ICONS.invoices
  },
  {
    label: 'report',
    key: 'report',
    to: '/report/medicus',
    icon: SIDEBAR_ICONS.report
  },
  {
    label: 'calendar',
    key: 'calendar',
    to: '/calendar',
    icon: SIDEBAR_ICONS.calendar
  },
  {
    label: 'video_call',
    key: 'video-call',
    to: '/video-call',
    icon: SIDEBAR_ICONS['video-call']
  },
  {
    label: 'dicom',
    key: 'dicom',
    to: '/dicom',
    icon: SIDEBAR_ICONS.dicom
  },
  {
    label: 'how_it_works',
    key: 'how-it-works',
    to: `/how-it-works/${DOCTOR_HOW_IT_WORKS_PAGES.DASHBOARD.key}`,
    icon: SIDEBAR_ICONS.howItWorks
  }
];
